export default __webpack_public_path__ + "static/media/claim-name.f3eb5bbf.svg";